import { useContext, useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { AppSpan, AppText, CustomContainer, FlexRow, GridContainer, Icon, Input, ScreenTitle } from "src/style"
import { AppCenterPopupD3, CenterPopupHeaderD3, SidePopupLayout } from "src/component"
import { FiSearch } from "react-icons/fi"
//import { billers } from "src/utils/mock-data"
// import {ReactComponent as BillIcon} from 'src/assets/img/t-bill-icon.svg'
import BillIcon from 'src/assets/svg/bills-tx-icon'
import { HiOutlinePlusSm } from "react-icons/hi"
import helpers from "src/utils/helpers"

export const BillersD3: React.FC<any> = ({categoryId, updateData, back, close}) => {
    const {API} = useContext(ApiContext)
    const [billers, setBillers] = useState<any>(null)
    const [mockBillers, setMockBillers] = useState<any>(null)

    useEffect(() => {
        handleFetchBillers()
    }, [])

    async function handleFetchBillers () {
        const response = await API.getBillers(categoryId)
        if (response) {
            setBillers(response)
            setMockBillers(response)
        }
    }

    function handleSearch (e: React.ChangeEvent<HTMLInputElement>) {
        setMockBillers(helpers.searchTableData(billers, e.target.value, ['billerName']))
    }

    function handleBiller (item: any) {
        updateData(item)
        back()
    }

    return (
        <AppCenterPopupD3 height='70' zIndex='6' overflow='hidden' close={close}>
            <CenterPopupHeaderD3 title='Select Biller Category' close={close} />
            <CustomContainer 
                height="70"
                style={{maxHeight: '100%'}}
                className="popup-content-container"
            >
                <CustomContainer
                    radius='0.8' borderColor='#D0D5DD' 
                    leftPadding='1.5' rightPadding='1.5' topMargin='2.5'
                    shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                    bottomMargin='2'
                >
                    <FlexRow>
                        <FiSearch style={{fontSize: '2rem', color: '#667085'}} />
                        <Input 
                            height='4.4' leftPadding='1' 
                            placeholder='Search' 
                            onChange={handleSearch}
                        />
                    </FlexRow>
                </CustomContainer>
                <CustomContainer
                    height='78' hUnit='%'
                    className='overflow-y-container'
                >
                    {
                        mockBillers?.map((item: any, index: number) => {
                            return (
                                <GridContainer 
                                    minHeight="7.2" key={index}
                                    className="beneficiary-container"
                                    onClick={() => handleBiller(item)}
                                >
                                    <FlexRow justifyContent="space-between" gap="1.5" rightPadding="1.5">
                                        <FlexRow width="auto" sizeUnit='' gap="1.5">
                                            <BillIcon className='icon-component'/>
                                            <AppText fontWeight="600" color="#101828" cursor="pointer">{item.billerName}</AppText>
                                        </FlexRow>
                                        <AppSpan textSize="2" color='#98A2B3'>
                                            <HiOutlinePlusSm/>
                                        </AppSpan>
                                    </FlexRow>
                                </GridContainer>
                            )
                        })
                    }
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopupD3>
    )
}
